/*=============================
=          Google Maps        =
=============================*/

import { MarkerClusterer } from '@googlemaps/markerclusterer';

var locationMaps = [].slice.call(document.querySelectorAll('.map-container')),
	isLocationPage = body.classList.contains('location'),
	isRegionTemplate = body.classList.contains('region');

if(locationMaps.length > 0)
	scriptWaypoint(locationMaps[0], 'https://maps.googleapis.com/maps/api/js?key=AIzaSyANyhSPmHRe3beHm50IIRE7twxvpDe6ncg&callback=initMap', '150%');

function initMap(mapElement) {
	var openWindow,
		locations,
		locationsList = mapElement.parentNode.querySelector('.sites'),
		currentMarker,
		mapLocation = mapElement.getAttribute('data-location'),
		markerSmall = {
			url: '/assets/images/icons/pin-unselected.png',
			scaledSize: new google.maps.Size(45, 52)
		},
		markerBig = {
			url: '/assets/images/icons/pin-selected'+(checkWidth(1200) ? '-mobile' : '')+'.png',
			scaledSize: new google.maps.Size((checkWidth(1200) ? 83 : 102), (checkWidth(1200) ? 96 : 117))
		};

	const resetLocations = function() {
		locations.forEach(function(locationItem, i) {
			moveLocations(locationItem, i+1, false, 'reset');
		});
	}

	const moveLocations = function(location, order, openAccordion, action) {
		const locationCard = locationsList.querySelector('li#'+location.id);

		locationsList.insertBefore(locationCard, locationsList.querySelector('li:nth-child('+order+')'));

		if(action == 'selected') {
			locationCard.classList.add('selected');
		} else if(action == 'reset') {
			locationCard.classList.remove('selected');
		}

		if(isRegionTemplate && checkWidth(768))
			toggleAccordionDisplay(locationCard.querySelector('button.accordion-button'), openAccordion);
	}

	const sortLocations = function(location) {
		// haversine formula to calculate distance between two points
		function calculateDistance(location1, location2) {
			const coords1 = JSON.parse('['+location1.coordinates+']');
			const coords2 = JSON.parse('['+location2.coordinates+']');
			const lat1 = coords1[0];
			const lon1 = coords1[1];
			const lat2 = coords2[0];
			const lon2 = coords2[1];
			const R = 6371e3; // Earth radius in meters
			const dLat = (lat2-lat1) * Math.PI/180;
			const dLon = (lon2-lon1) * Math.PI/180;

			const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
					  Math.cos(lat1 * Math.PI/180) * Math.cos(lat2 * Math.PI/180) *
					  Math.sin(dLon/2) * Math.sin(dLon/2);

			const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

			return R * c; // Distance in meters
		}

		const sortedLocations = locations.slice().sort((a, b) => {
			const distA = calculateDistance(location, a);
			const distB = calculateDistance(location, b);

			return distA - distB;
		});

		sortedLocations.forEach(function(locationItem, i) {
			i = i+1;
			moveLocations(locationItem, i, i===1, (i===1 ? 'selected' : ''));
		});
	}

	axios.get('/map-section/'+mapLocation).then(function(r) {
		locations = r.data.locations;

		var center = JSON.parse('['+r.data.center+']'),
			centerMobile = r.data.centerMobile ? JSON.parse('['+r.data.centerMobile+']') : '',
			// bounds = new google.maps.LatLngBounds(),
			zoom = r.data.zoom,
			mapOptions = {
				zoom: body.classList.contains('mobile') ? (mapLocation == 'ny' ? (zoom-1) : (r.data.centerMobile ? r.data.zoomMobile : zoom)) : zoom,
				streetViewControl: false, // hide the yellow Street View pegman
				scaleControl: true, // allow users to zoom the Google Map
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				disableDefaultUI: true,
				// scrollwheel: false,
				styles: mapStyles,
				zoomControl: true,
				gestureHandling: 'cooperative',
				center: body.classList.contains('mobile') && r.data.centerMobile ? new google.maps.LatLng(centerMobile[0], centerMobile[1]) : new google.maps.LatLng(center[0], center[1])
			},
			markers = [],
			map = new google.maps.Map(mapElement, mapOptions);

		locations.forEach(function(location) {
			var coordinates = JSON.parse('['+location.coordinates+']'),
				latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
				marker = new google.maps.Marker({
					map: map,
					position: latLng,
					draggable: false,
					// animation: google.maps.Animation.DROP,
					icon: markerSmall
				}),
				isNassau = location.uri == 'locations/long-island-nassau-county',
				pixelX = isLocationPage ? 0 : (checkWidth(1200) ? 182 : 200),
				pixelY = isLocationPage ? (checkWidth(768) ? 268 : ((checkWidth(1200) ? 302 : 332) + (isNassau ? 32 : 0))) : 150,
				infowindow = new google.maps.InfoWindow({
					position: latLng,
					content: location.html,
					// headerDisabled: true,
					pixelOffset: new google.maps.Size(pixelX, pixelY)
				});

			if(location.openWindow) {
				infowindow.open(map, marker);
				openWindow = infowindow;

				marker.setIcon(markerBig);
				currentMarker = marker;
			} else {
				// bounds.extend(marker.position);
			}

			infowindow.addListener('closeclick', function() {
				openWindow = false;
				currentMarker.setIcon(markerSmall);

				if(!isLocationPage)
					resetLocations();
			});

			markers.push(marker);

			marker.addListener('click', function() {
				if(currentMarker)
					currentMarker.setIcon(markerSmall);

				if(openWindow)
					openWindow.close();

				if(currentMarker != marker) {
					marker.setIcon(markerBig);
					currentMarker = marker;

					if(!isLocationPage) {
						resetLocations();
						sortLocations(location);
					}

					if(isLocationPage || !checkWidth(768)) {
						infowindow.open(map, marker);
						openWindow = infowindow;
					}
				} else {
					openWindow = false;
					currentMarker = false;

					if(!isLocationPage)
						resetLocations();
				}
			});
		});

		// Cluster Pin Styling
		let renderer = {
			render({ count, position }, stats) {
				const svg = window.btoa(`
				<svg width="45" height="52" viewBox="0 0 45 52" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1208_3468)"><path d="M38.6958 16.4831C38.6958 25.2934 22.7434 39.4524 22.7434 39.4524C22.7434 39.4524 6.79102 25.2934 6.79102 16.4831C6.79102 7.67288 13.9331 0.530762 22.7434 0.530762C31.5536 0.530762 38.6958 7.67288 38.6958 16.4831Z" fill="#FD7B7B"/></g><defs><filter id="filter0_d_1208_3468" x="0.697981" y="0.530762" width="44.0904" height="51.1079" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="6.09303"/><feGaussianBlur stdDeviation="3.04652"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1208_3468"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1208_3468" result="shape"/></filter></defs></svg>`);
				return new google.maps.Marker({
					position,
					icon: {
						url: `data:image/svg+xml;base64,${svg}`,
						scaledSize: new google.maps.Size(45, 52),
					},
					label: {
						text: String(count),
						className: 'custom-cluster',
						color: '#000',
						fontFamily: "'Poppins', sans-serif",
						fontSize: '1rem',
						fontWeight: '600'
					},
					title: `Cluster of ${count} markers`,
					// zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
					// animation: google.maps.Animation.DROP,
				});
			}
		}

		// Position locations on top on cluster click
		const onClusterClick = function(e, cluster, map) {
			if(!isLocationPage) {
				resetLocations();

				let newIndex = 1;

				markers.forEach(function(marker, i) {
					cluster.markers.forEach(function(clusterMarker) {
						if(clusterMarker == marker)
							moveLocations(locations[i], newIndex++, true, '');
					});
				});
			}

			map.fitBounds(cluster.bounds);
		}

		// Build Cluster Markers
		new MarkerClusterer({markers, map, renderer, onClusterClick});
			
		// Helper for map adjustments
		// map.addListener('center_changed', () => {
		// 	console.log(map.getCenter(), map.getZoom());
		// });

		// Fit all markers
		// if(!body.classList.contains('location'))
		// 	map.fitBounds(bounds, [0]);
	});
}

if(locationMaps.length) {
	window.initMap = function() {
		locationMaps.forEach(function(mapElement) {
			if(mapElement.classList.contains('loaded') || !body.classList.contains('locations'))
				initMap(mapElement);
		});
	};
}

[].slice.call(document.querySelectorAll('.accordion-locations button:not(.open)')).forEach(function(button) {
	button.addEventListener('click', function() {
		var map = this.nextElementSibling.querySelector('.map-container');

		if(map && !map.classList.contains('loaded')) {
			initMap(map);
			map.classList.add('loaded');
		}
	});
});

window.onunload = function () {
	if(body.classList.contains('locations'))
		window.scrollTo(0, 0);
};

/*=============================
=          Statistics         =
=============================*/

[].slice.call(document.querySelectorAll('.statistics-container')).forEach(function(statisticsContainer) {
	var statisticsAnimation = new Waypoint({
		element: statisticsContainer,
		handler: function(direction) {
			[].slice.call(statisticsContainer.querySelectorAll('.stat')).forEach(function(stat) {
				animateCountUp(stat);
			});

			this.destroy();
		},
		offset: '85%'
	});
});

// How long you want the animation to take, in ms
const animationDuration = 750;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 2000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round(animationDuration / frameDuration);
// An ease-out function that slows the count as it progresses
const easeOutQuad = t => t * (2 - t);

// The animation function, which takes an Element
const animateCountUp = el => {
	let frame = 0;
	let num = el.querySelector('.number span.num');

	const countTo = parseInt(num.innerHTML, 10);
	// Start the animation running 60 times per second
	const counter = setInterval(() => {
		frame++;
		// Calculate our progress as a value between 0 and 1
		// Pass that value to our easing function to get our
		// progress on a curve
		const progress = easeOutQuad(frame / totalFrames);
		// Use the progress value to calculate the current count
		const currentCount = Math.round(countTo * progress);

		// If the current count has changed, update the element
		if(parseInt(num.innerHTML, 10) !== currentCount)
			num.innerHTML = currentCount.toLocaleString('en-US');

		// If we’ve reached our last frame, stop the animation
		if(frame === totalFrames) {
			clearInterval(counter);
			el.classList.add('done');
		}
	}, frameDuration);
};

/*=============================
=        What To Expect       =
=============================*/

var expectImage = document.querySelector('body#what-to-expect #hero.simple figure.desktop');

if(expectImage && !checkWidth(1024)) {
	window.addEventListener('scroll', function() {
		var pageOffset = window.pageYOffset;

		expectImage.style.transform = 'translate3d(0px, -'+(pageOffset / 2)+'px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)';
	});
}